import ProductRating from '@nespresso/catalog-components-react/controls/ProductRating';
import type { Product } from '@/domain/Product';
import useTranslations from '@/widgets/hooks/useTranslations.tsx';
import styles from './ProductFeaturesSection.module.scss';
import useWidgetOptions from '@/widgets/hooks/useWidgetOptions';
import type { Options } from '../../config/index.ts';

export type ProductFeaturesSectionProps = {
  product: Product;
};

export default function ProductFeaturesSection({
  product
}: ProductFeaturesSectionProps) {
  const { t } = useTranslations();
  const { ratings } = useWidgetOptions<Options>();
  const productRatingsId = ratings?.productRatingsId;

  const ariaLabel = (rating: string, maxRating: string) =>
    t('productFeaturesSection.rating.ariaLabel', { rating, maxRating });

  const reviewCountTitle = (reviewCount: number) =>
    t('productFeaturesSection.rating.reviewCountTitle', { reviewCount });

  return (
    <section class={styles.container}>
      <ProductRating
        rating={Number(product.rating?.ratingAverage)}
        decimalPrecision={1}
        ariaLabel={ariaLabel}
        reviewCount={product.rating?.reviewCount}
        reviewCountTitle={reviewCountTitle}
        href={productRatingsId ? `#${productRatingsId}` : undefined}
      />
    </section>
  );
}

ProductFeaturesSection.Skeleton = function Skeleton() {
  return null;
};
